import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'font-awesome/css/font-awesome.min.css';

class TextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: "",
        };
    }

    // Configuración de módulos (barra de herramientas)
    modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{'align': []}], // Añadir la opción de alineación
        ],
    };

    // Formatos permitidos en el editor
    formats = [
        'bold', 'italic', 'underline', 'strike',
        'align', // Añadir 'align' a los formatos permitidos
    ];

    // Función que maneja los cambios en el contenido del editor
    handleChange = (value) => {
        this.setState({ text: value });
        console.log(value);
    };

    render() {
        return (
            <div className="w-full text-editor flex flex-col-reverse">
                <div className="ql-container-wrapper flex flex-col-reverse">
                    <ReactQuill
                        theme="snow"
                        value={this.state.text}  // Vincula el contenido del editor con el estado
                        onChange={this.handleChange}  // Actualiza el estado cuando el contenido cambie
                        modules={this.modules}  // Configura la barra de herramientas
                        formats={this.formats}  // Configura los formatos permitidos
                    />
                </div>
            </div>
        );
    }
}

export { TextEditor };
